import styled, { keyframes } from 'styled-components';

const flash = keyframes`
 0% {
   opacity: 0;
 }

 50% {
   opacity: 1;
 }

 100% {
   opacity: 0;
 }
`;

const LiveIcon = styled.span`
  display: block;
  border-radius: 50%;
  width: 8px;
  height: 8px;
  background-color: var(--color-red);
  animation: ${flash} 2s linear infinite;
`;

export default LiveIcon;
